import React from 'react';
import Loader from 'react-loader-spinner';
import {string} from 'prop-types';
import { z_index } from 'const/zIndex';

const ContentLoader = ({backgroundColor = 'black'}) => {
  return (
    <div
      style={{
        zIndex: z_index?.loadin,
        backgroundColor: backgroundColor,
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        top: '0',
      }}
    >
      <Loader type="Oval" color="#8A0101" height={60} width={60} />
    </div>
  );
};

ContentLoader.propTypes = {
  backgroundColor:string,
}

export default ContentLoader;
